module.exports = __webpack_public_path__ + "img/SBATWeb-min.b8cb54c2.jpg";